export const FETCH_LEFTMENU_BEGIN="FETCH_LEFTMENU_BEGIN";
export const FETCH_LEFTMENU_SUCCESS="FETCH_LEFTMENU_SUCCESS";
export const FETCH_LEFTMENU_FAILURE="FETCH_LEFTMENU_FAILURE";